var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "disclosureIcp_set"
  }, [_c("a-form-model", {
    attrs: {
      model: _vm.form
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("是否展示披露页")
    }
  }, [_c("a-radio-group", {
    on: {
      change: function ($event) {
        return _vm.changeFun("disclosure", $event);
      }
    },
    model: {
      value: _vm.form.controlsDisclosurePageDisplay,
      callback: function ($$v) {
        _vm.$set(_vm.form, "controlsDisclosurePageDisplay", $$v);
      },
      expression: "form.controlsDisclosurePageDisplay"
    }
  }, [_c("a-radio", {
    attrs: {
      value: true
    }
  }, [_vm._v(" " + _vm._s(_vm.$t(`是`)) + " ")]), _c("a-radio", {
    attrs: {
      value: false
    }
  }, [_vm._v(" " + _vm._s(_vm.$t(`否`)) + " ")])], 1)], 1), _vm.form.controlsDisclosurePageDisplay ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("披露页展示")
    }
  }, [_c("a-radio-group", {
    model: {
      value: _vm.form.controlsDisclosurePageExhibitor,
      callback: function ($$v) {
        _vm.$set(_vm.form, "controlsDisclosurePageExhibitor", $$v);
      },
      expression: "form.controlsDisclosurePageExhibitor"
    }
  }, [_c("a-radio", {
    attrs: {
      value: 1
    }
  }, [_vm._v(" " + _vm._s(_vm.$t(`承保机构`)) + " ")]), _c("a-radio", {
    attrs: {
      value: 2
    }
  }, [_vm._v(" " + _vm._s(_vm.$t(`中介机构`)) + " ")])], 1)], 1) : _vm._e(), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("是否展示icp备案号")
    }
  }, [_c("a-radio-group", {
    on: {
      change: function ($event) {
        return _vm.changeFun("icp", $event);
      }
    },
    model: {
      value: _vm.form.controlsICPDisplay,
      callback: function ($$v) {
        _vm.$set(_vm.form, "controlsICPDisplay", $$v);
      },
      expression: "form.controlsICPDisplay"
    }
  }, [_c("a-radio", {
    attrs: {
      value: true
    }
  }, [_vm._v(" " + _vm._s(_vm.$t(`是`)) + " ")]), _c("a-radio", {
    attrs: {
      value: false
    }
  }, [_vm._v(" " + _vm._s(_vm.$t(`否`)) + " ")])], 1)], 1), _vm.form.controlsICPDisplay ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("icp备案号展示")
    }
  }, [_c("a-radio-group", {
    model: {
      value: _vm.form.controlsICPExhibitor,
      callback: function ($$v) {
        _vm.$set(_vm.form, "controlsICPExhibitor", $$v);
      },
      expression: "form.controlsICPExhibitor"
    }
  }, [_c("a-radio", {
    attrs: {
      value: 1
    }
  }, [_vm._v(" " + _vm._s(_vm.$t(`承保机构`)) + " ")]), _c("a-radio", {
    attrs: {
      value: 2
    }
  }, [_vm._v(" " + _vm._s(_vm.$t(`中介机构`)) + " ")])], 1)], 1) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };